module.exports = __webpack_public_path__ + "img/monitoringdescription5.1f85ca27.png";